import React, { useRef, useState, useEffect } from 'react'
import { func, shape, string, bool } from 'prop-types'
import Popper from '@mui/material/Popper'
import Grow from '@mui/material/Grow'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import { KeyboardArrowDown } from '@mui/icons-material'
import Typography from '@mui/material/Typography'
import { withStyles } from '~/themes/useStyles'
import { DISCOUNT_TYPE } from '~/constants/promotion'
import NumberInput from '../NumberInput'
import style from './style'

const options = [
  {
    label: 'Percentage',
    value: DISCOUNT_TYPE.PERCENTAGE,
    unit: '%',
  },
  {
    label: 'Fixed Amount',
    value: DISCOUNT_TYPE.FIXED_AMOUNT,
    unit: '$',
  },
]

/**
 @deprecated We should use AmountWUnitInput
*/
const DiscountInput = ({
  classes,
  onSelect,
  type,
  disabled,
  helperText,
  ...props
}) => {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = false
  }, [open])

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const handleSelect = (val) => {
    onSelect(val)
    setOpen(false)
  }

  const renderUnit = () => {
    switch (type) {
      case DISCOUNT_TYPE.PERCENTAGE:
        return '%'
      case DISCOUNT_TYPE.FIXED_AMOUNT:
        return '$'
      default:
        return ''
    }
  }
  const renderAdorment = () => (
    <Box display="flex" alignItems="center" pr={disabled ? 1 : 0}>
      <Typography className={classes.unit}>{renderUnit()}</Typography>
      {disabled || (
        <IconButton size="small" onClick={handleToggle}>
          <KeyboardArrowDown color="primary" />
        </IconButton>
      )}
    </Box>
  )

  return (
    <Box className={classes.discountInput}>
      <NumberInput
        inputRef={anchorRef}
        disableScrollAction
        containerClassName={classes.numberInputNoArrow}
        helperText={helperText}
        InputProps={{
          endAdornment: renderAdorment(),
        }}
        disabled={disabled}
        {...props}
      />
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        className={classes.poper}
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                >
                  {options.map((item) => (
                    <MenuItem
                      key={item.value}
                      style={{ fontSize: 14 }}
                      onClick={() => handleSelect(item.value)}
                    >
                      {item.label}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  )
}

DiscountInput.defaultProps = {
  type: '',
  helperText: '',
  disabled: false,
}

DiscountInput.propTypes = {
  classes: shape().isRequired,
  onSelect: func.isRequired,
  disabled: bool,
  type: string,
  helperText: string,
}

export default withStyles(style)(DiscountInput)
